// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y_dY","index":"styles_index__gASRE"};